export default function () {
  const componentSelector = ".spotlights";
  const swiperSelector = ".spotlights__swiper";
  const prevSelector = ".spotlights__nav-prev";
  const nextSelector = ".spotlights__nav-next";

  const components = document.querySelectorAll(componentSelector);
  if (!components.length) return;
  
  const syncNavState = (swiper, prevButton, nextButton) => {
    if (!swiper) return;

    if (prevButton) prevButton.disabled = swiper.isBeginning;
    if (nextButton) nextButton.disabled = swiper.isEnd;
  };

  components.forEach((component) => {
    const swiperEl = component.querySelector(swiperSelector);
    if (!swiperEl) return;

    const prevButton = component.querySelector(prevSelector);
    const nextButton = component.querySelector(nextSelector);

    new Swiper(swiperEl, {
      direction: "horizontal",
      slidesPerView: "auto",
      centeredSlides: true,
      spaceBetween: 16,
      grabCursor: true,
      watchSlidesProgress: true,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
      a11y: {
        enabled: true,
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
      },
      breakpoints: {
        640: {
          spaceBetween: 24,
        },
        1024: {
          spaceBetween: 32,
        },
        1280: {
          spaceBetween: 40,
        },
      },
      on: {
        init() {
          syncNavState(this, prevButton, nextButton);
        },
        slideChange() {
          syncNavState(this, prevButton, nextButton);
        },
        reachBeginning() {
          syncNavState(this, prevButton, nextButton);
        },
        reachEnd() {
          syncNavState(this, prevButton, nextButton);
        },
      },
    });
  });
}
